"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHistory = void 0;
exports.getHistory = `
    fragment CommonEvent on memberHistoryCommonEvent {
        id
        name
        origin
        dateTime {
            iso8601
        }
    }
    
    fragment Budget on calorieBudget {
        calories
        fats
        carbohydrates
        fibers
        proteins
    }
    
    fragment CalorieBudgetAdjustedEvent on memberHistoryCalorieBudgetAdjustedEvent {
        id
        name
        origin
        dateTime {
            iso8601
        }
        prevBudget {
            ...Budget
        }
        nextBudget {
            ...Budget
        }
    }

    query MemberHistory($memberId: ID!, $after: ID) {
        memberHistory(memberId: $memberId, after: $after, limit: 10) {
            events {
                ...CommonEvent,
                ...CalorieBudgetAdjustedEvent
            }
        }
    }
`;
//# sourceMappingURL=index.js.map